module.exports = __webpack_public_path__ + "img/radio.9896d293.svg";